module.exports = __webpack_public_path__ + "static/media/contact.17efd392.svg";